
import OfficeBlock from './components/OfficeBlock';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import {useNavigate} from 'react-router-dom';

export default function LocationPage() {

  const navigate = useNavigate();

  return (
    <div>
      <Header/>
      <main
        data-bg-type='white'
        className='wrapper my-[100px] lg:my-[160px]'
      >
        <h1 className='text-title3 font-bold lg:text-display3 text-center'>오시는 길</h1>

        <section className='px-[5%] mt-[140px] lg:mt-[320px]'>
          <div className='text-title3 font-bold lg:text-display2 text-center text-label-500'>
            사업장 방문은 사전 예약 후 방문하여 주시기 바랍니다.
          </div>

          <div className='flex justify-center mt-[60px]'>
            <button
              onClick={() => navigate('/contact?type=reserve')}
              className='w-full py-[16px] lg:w-auto lg:px-[90px] lg:py-[30px] text-heading3 lg:text-title2'>
              방문 예약하기
            </button>
          </div>
        </section>


        <section className='flex flex-col items-center justify-center gap-[120px] lg:px-[20%] mt-[120px] lg:mt-[240px]'>
          <OfficeBlock
            name='본사'
            address='경상북도 칠곡군 왜관읍 2산업단지2길 111, 에이동 2층'
            lat={35.9456416432034} lng={128.402955034194}
          />

          <OfficeBlock
            name='연구소'
            address='경기도 성남시 중원구 양현로 409, 어반스퀘어 802호'
            lat={37.4171197166796} lng={127.127403122464}
          />

          <OfficeBlock
            name='생산공장'
            address='경상북도 구미시 산호대로 253, 구미첨단의료기술타워 912호 ㈜모듈링크'
            lat={36.1065077497235} lng={128.384455519754}
          />
        </section>
      </main>

      <Footer/>
    </div>
  )
}